const UIEVENTS_PUSH = 'app/uiEvents/pushEvent';
const UIEVENTS_REMOVE = 'app/uiEvents/removeEvent';

export { UIEVENTS_PUSH, UIEVENTS_REMOVE };
